module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("3")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indenti"
  }, [_vm._v("After my excruciatingly long shift at the bar ended, I spent the remainder of the night holed up in my house, watching for additional news reports and waiting for my local magical lodge to open its doors the next morning. They officially opened at nine, but sometime around seven I became impatient.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morning traffic made a fifteen-minute drive twice as long and strained my already frazzled nerves. I parked my gunmetal gray Jetta near a warehouse two blocks away from the lodge in an area called Wildewood Park, an eclectic neighborhood composed of abandoned factories and a mixture of low- to middle-income ranch houses built in the 1960s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though I felt pretty confident about the security of my current identity and didn’t believe I was in immediate danger of being tracked down by the Luxe, walking into the local lodge in broad daylight made me slightly paranoid. For all I knew, people could be staking it out. I mumbled a quick spell and charged one of the sigils on my arm to further obscure my identity, just to be safe. I tugged my purse higher up on my shoulder after the nausea subsided, then slunk down the cracked sidewalk.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Ekklesia Eleusia, or E∴E∴ as it is known in the magical community, is an occult order founded in the late twelfth century in France, which makes it the longest-running esoteric society in the world. Like every other order, it’s a nonprofit, tax-exempt organization, and dedicated to the “Study, Knowledge, and Advancement of the Arcane Arts.” Kinda like Hog-warts, only with fewer wands and more nudity.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The order moved its operational headquarters from Europe to the States in the early twentieth century, along with two other occult orders. There were a couple thousand E∴E∴ members scattered around a handful of U.S. lodges. The main lodge in Florida, where I grew up, was impressive; the local lodge here in Morella is not. Fewer than a hundred members attended regular ritual services and classes here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The morning sun was blinding as I stepped out of early-autumn shadows and made my way to the side door of the lodge. Two scraggly, underwatered palm trees flanked the entrance. I rang the doorbell and noticed a couple of rental cars in the back parking lot. This made me a little nervous, but before I could think about it too much, a short man with cropped blond hair opened the door: the Grandmaster’s assistant. He gave me a nasty little smile as he greeted me by my birth name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Soror Seléne, my … "), _c('em', [_vm._v("heart")]), _vm._v(" expands in your presence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rolled my eyes and begrudged a formal acknowledgment. “Frater Kantor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You look as if you didn’t get much sleep either last night, Soror. Too bad we couldn’t have stayed up together.” His eyes lingered over my breasts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That will never, ever happen, Frater.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A shame. With my brains and your bloodline …”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Ah, yes. My freaking bloodline. My order called me a ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Moonchild. Heralded as a kind of saint, I was conceived during an elaborate series of secret magical sex rituals between my parents. At best, the expected result of these rituals was to create a new godlike being, something between Jesus and "), _c('em', [_vm._v("Rosemary’s Baby")]), _vm._v(". At worst, it was just selective esoteric breeding between two powerful and once-respected magicians.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Apart from my preternatural vision, the small silver halo—that nobody but me and Earthbounds could see—and an innate knack for kindling Heka, I was pretty sure the rest of it was a crock of shit. Still, before the Black Lodge slayings changed everything, the occult community was buzzing about my potential. I was eighteen and just coming into my abilities. I was a big deal. Now only a handful of trusted people in my organization acknowledged my existence; how the mighty have fallen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speaking of my bloodline, Frater Kantor, if you continue to harass me every time I come to the Morella Lodge, I’m going to pull rank and get you kicked out of the damn order.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My apologies, Soror.” He couldn’t have meant it less. “Perhaps you’ll be happy to know that Caliph Superior from the Florida lodge is inside waiting for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rental cars outside … this was serious. I hadn’t seen Caliph Superior in person since I’d gone into hiding. We’d only communicated by phone and email, occasionally through our guardians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pushed Frater Kantor aside and walked into the lodge, the heels of my boots clicking on the tiled floor in the darkened, cool hallway. Frater Kantor locked the outside door, then hurried to get in front of me as I made it to the back offices. Before he could announce me, the local Grandmaster stood up. But I couldn’t have cared less about her; it was the man behind her I wanted to see.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“Seléne, my darling,” he said. “It’s so good to see you again.”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A swell of emotion caught me by surprise at the sight of him. It took me a moment to answer. “Godfather.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He held out his arms to me. I stepped forward into his embrace allowed him to kiss me, once on each cheek. He smelled familiar and earthy. Safe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Caliph Superior was in his early seventies. His once long, white hair was now short and thinning. Apart from wearing a large gold ring bearing an engraved unicursal hexagram, you wouldn’t have a clue that he was the leader of one of the most powerful magical organizations in the Western world. In his expensive suit, he looked more like a retired lawyer or someone’s rich grandfather—both of which he was. He had seven children by four different women, and a slew of grandchildren, all of whom could claim a lineage extending back to beginnings of the order. One of them would take over as leader when he died.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Soror Yolanda,” I said, nodding my head toward the Grandmaster. She nodded back and motioned for me to take a seat in a cracked leather armchair that was grouped with several others in front of an unlit fireplace. A painting of a Sumerian war goddess hung above the mantel between a William Blake print and an engraving of John Dee and Edward Kelley evoking a spirit. Caliph Superior sat down next to me while the Grandmaster shooed away her wormy assistant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t believe how much you’ve changed,” Caliph Superior said. “To see you in person instead of photos … ah, my goddaughter became a woman.” His eyes glazed over with emotion as he reached to touch my face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You cut your hair.” I smiled at him while brushing away a stray tear before it could fall.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“You grew yours out. It’s lovely.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The last time I’d seen him, my hair was cropped short. Now it fell to the middle of my back. Naturally a dark brunette, I started bleaching the underside white-blond; Kar Yee said it made me look like Pepé Le Pew’s girlfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Contacts?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.” Blues were now brown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sighed and withdrew his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the three of us were alone, the Grandmaster sat in front of us and gave me a grave look. An attractive woman in her fifties, she had severe, thin lips that seemed out of place on an otherwise round face and plump body. I hadn’t had much contact with her since I’d moved to Morella two years ago; I did my best to avoid the E∴E∴ in my new life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s going on? Why wasn’t I informed that my parents were coming to the States?” I looked between the two of them. Caliph Superior spoke first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We didn’t inform you because we ourselves didn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They haven’t contacted you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook his head. “No. Nothing has changed. You know that when all of you went into hiding I agreed not to contact your parents, even through our guardians. As far as the authorities go, I’m sure Elona and Alex have hidden themselves well by now. There’s no way to authenticate their identity on the video footage. The FBI will give a cursory search, then move on to something more important when the scandal dies down. You shouldn’t worry about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. He was probably right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right now,” he added, “we have bigger problems than the FBI.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Luxe,” I said in a low voice. “They know, don’t they?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Based out of San Diego, the Luxe Order was a rival occult organization that boasted a membership of five thousand. Though the E∴E∴ could claim only about two thousand members, we were older and more elite. The two organizations were the largest and most respected of all the international esoteric orders, but often butted heads on philosophy and had a long history of fighting—with both public lawsuits and private magical sabotage. So when the Luxe leader pointed the finger at my parents and cried “killers,” no one in the E∴E∴ was surprised; Luxe would do anything to discredit us.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Grandmaster crossed her legs and answered. “All the organizations know, but Luxe has taken the lead on this, as usual. Your parents will have to do some deft maneuvering to get away from their spies … but that’s not why we want to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Caliph Superior put his hand on top of mine. “Seléne, darling, the Luxe head is demanding that we turn your parents over to them for retribution.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Retribution? For crimes they didn’t commit?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but that’s of no consequence at this point. It took us a long time to negotiate and make peace with all the other orders after the killings—especially Luxe. Now that they know we lied to them about your parents being dead, they’ve banded together with the lower orders and they’ve all agreed that they want compensation for their … losses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Losses? What did Luxe lose? No one was even killed in their order. And since when do any of the orders band together for anything?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("“Since now, I suppose. Luxe is the biggest and strongest, so they are the ones chosen by the smaller orders to flex ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("muscle. They’ve issued us a mandate. We have two weeks to hand over your parents to the Luxe Order in a special council they are arranging, or they are declaring magical war against us.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My chest tightened. Occult societies have a tendency to operate outside the law. I hadn’t lived through a magical war myself, but I’d read accounts of past conflicts. Each order has its own military of sorts, an elite group of magicians proficient in summoning and controlling godforms and Æthyric elder demons—the big, bad immortal kind. Ancient demons that could be bound to kill on command … like the demon that someone had summoned seven years ago, that killed the three rival magicians, whose deaths were pinned on my parents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Black Lodge slayings consisted of three separate murders that occurred over six weeks’ time. The first killing was the head of a small hermetic order in England. The second was the head of a similar order in Boston, and the third was the head of a slightly larger order based in Portland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fourth and last attempted murder of the leader of the Luxe Order, occurred in San Diego. Only, that attempt failed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Luxe has given us one other option,” the Grandmaster said as she toyed with a small charm that dangled from a long silver chain around her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes?” I prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Give you up as payment for your parents’ alleged sins.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alarmed, I stiffened and straightened in my seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Darling, we would never do that,” Caliph Superior assured me, cutting his eyes at the Grandmaster. “You’re far too valuable to our organization.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that the only reason?” My voice was more acerbic than I intended.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Of course not,” he replied with a calm tenderness. “I ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("love you as if you were my own flesh and blood. I would give up your parents before I—”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Caliph!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Calm down, child. I’m not suggesting that we do that, either, for the time being.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you suggesting?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Caliph Superior held up one finger against his lips then looked at the Grandmaster and made a circular gesture. She got up from her seat and picked up a worn piece of paper off her desk. I recognized the silencing ward drawn on it as she carried it over to the door. Setting it on the floor, she pulled a small lancet out of her pocket, pricked her finger, and squeezed out a single drop of blood onto the spell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She could have used saliva; whatever they were going to tell me, they really didn’t want anyone else to hear. She lost her balance for a second, then steadied herself. Probably had been doing warding spells all night and needed a rest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she’d finished charging the ward, she returned to us and sat down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen well,” the caliph warned. “Your parents believe that the demon that killed the three Luxe mages was very, very old. Primordial. As you know, they’ve been trying to identify it for years. We’ve long ago exhausted our own library and resources trying to help them find it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I crossed my arms in front of me as a resentful anger bubbled to the surface. “I offered to help summon it years ago, but they always refused to give me any details about the demon. I understand their being overprotective of a young girl, but I’m not a teenager anymore.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“Yes, I know that,” the caliph said with a gentle smile. “To be honest, all we have ourselves is a description of the demon and a knowledge of how he killed the victims. It’s not much to ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("go on, but if we could find new resources, perhaps we could locate the exact class of demon and, more important, the summoning name.”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hell, yeah, it was more important. There are a finite number of seals used for summoning Æthyric demons to earth. Each type of demon—Jinn, Kerub, Shedu, Oni, Asura, et cetera—requires a seal specific to its class. The variable is the addition of the demon’s name. Without the name, the demon can’t be summoned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if you could find the demon’s name,” the Grand-master added, “then, with your summoning abilities, you could certainly control him, and bind him in front of the Luxe council. Like every other demon, he can be forced—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To tell the truth,” I finished. “Yes, I’m well aware of the reason they’ve been searching for this demon all these years.” It would be the perfect witness to the murders. If he could be found and bound, he would tell everyone who really summoned and commanded him to kill those three people. It would exonerate my parents. Problem was, nobody knew what demon they were looking for. “How can we find the demon’s class and name in two weeks, when you’ve been working on it for years?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is nothing more that I can do personally, but perhaps there is something "), _c('em', [_vm._v("you")]), _vm._v(" can do. We’ve protected you from this for too long. Like you said, you’re an adult now, and a powerful mage. I know you’ve been studying and working with other magicians outside the order—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else could I do?” I snapped, knowing this was prohibited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You did what you had to. But if I’m guessing correctly, I think you may have contacts and sources that could bring a fresh perspective to the hunt.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("My brain began firing as I assembled a short list of options I could try. “If you can give me some more details about the demon in question, maybe.”")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, my dear, ‘maybe’ is all we have right now. If the demon can’t be identified conclusively …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then what?” I challenged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then,” he replied after a long sigh, “we’re going to have to comply with the Luxe Order’s mandate and give up your parents.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A strangled protest got caught in my throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know this is hard to hear, but we really don’t have another choice. We can’t afford a war right now. Times have changed, society is sharper and smarter than it was a hundred years ago. The savages won’t look the other way if more people are killed, and there’s been too much harsh light shed on our organization over the murders as it is. A magical war could mean the end of the E∴E∴ and, as its leader, I can’t allow that to happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard what he was saying, but I couldn’t accept it. We argued for several minutes, going around in circles, until I acquiesced and shut up. He gave me the description of the demon and what little information he had on the seal; it wasn’t much to go on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is happening so fast.” I felt like I was being sucked into a whirlpool with no chance of escape.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grasped my hands together in my lap. “If there’s anyone to blame in this, you can point the finger at me. Your parents insisted on keeping you out of this mess, but I should have fought them. Even now, I’m sure they wouldn’t approve of my asking you to do this for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, since no one can contact them right now, I guess they don’t get a vote.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“Darling, you’re a better magician than either one of them—even better than me, and that’s the truth. Maybe that’s due to your special conception, but even without it, I know in my heart that you’re strong. If anyone can help them, it’s you.”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared at the fireplace, hearing his words, but inwardly making plans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have a place in mind that you can begin your search?” the caliph asked. For the first time since I’d arrived, I noticed a little worry in his face and wondered if he really believed that I could do this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” I answered with as much certainty as I could muster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the middle of the chaos swirling around in my head, one local resource stood above everyone else who might help me, someone that no member of the E∴E∴ or any other magical order would ever consider asking, because of centuries-old prejudices and mistrust: a retired priest. One who wasn’t a savage … or even human, for that matter.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7249d7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 87
// module chunks = 0